<template>

  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>

    <div class="form-content py-4">
      <div class="row px-3">
        <h2 class="form-title-principal form-title col-12">Datos del usuario</h2>
        <p class="ml-0 col-12"><b>Nombre y apellidos: </b> {{detalleReclamo.name}}</p>
        <p class="ml-0 col-12"><b>DNI: </b> {{detalleReclamo.document}}</p>
        <p class="ml-0 col-12"><b>Direccion: </b> {{detalleReclamo.direction}}</p>
        <p class="ml-0 col-12"><b>Teléfono: </b>{{detalleReclamo.phone}}</p>
        <p class="ml-0 col-12"><b>E-mail: </b> {{detalleReclamo.email}}</p>
        <p class="ml-0 col-12"><b>Fecha de reclamo: </b> {{detalleReclamo.created_at}}</p>
      </div>
      <div class="row px-3 pt-4">
        <h2 class="form-title-principal form-title col-12">Cuéntanos que pasó...</h2>
        <p class="ml-0 col-12">
          <b>Tipo de reclamo:  </b>
          {{detalleReclamo.type}}
        </p>
        <p class="ml-0 col-12">
          <b>Servicio o producto del reclamo:  </b>
           {{detalleReclamo.store_id === 1?'SENDI':'ENVIOS USA'}}
        </p>
        <p class="ml-0 col-12">
          <b class="d-block mb-2">¿Cuál fué el problema?</b>
          <span class="d-block">
             {{detalleReclamo.problem}}
          </span>
        </p>
        <p class="ml-0 col-12">
          <b class="d-block mb-2">¿Qué solución esperas?</b>
          <span class="d-block">
             {{detalleReclamo.solution}}
          </span>
        </p>
      </div>
    </div>          
  </div>
</template>
<style>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.link {
  color: #1f5ee7 !important;
  text-decoration: underline;
}

.user {
  font-weight: 600;
  margin: 0;
  padding: 0;
}
</style>
<script>
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import axios from "axios";
export default {
  components: { breadcrumb, },
  created() {},
  data() {
    return {
      detalleReclamo: null,
      nameSection: "Detalle del reclamo",
      listRoutes: [{ nameRoute: "Reclamaciones", titleRoute: "Reclamos de usuarios" }],
      is_loading: true,
      idReclamo:this.$route.params.id,
    };
  },
  created() {
    this.getDetaileReclamo();
  },
  methods: {
    getDetaileReclamo() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/view/reclamo/"+this.idReclamo;
      // eslint-disable-next-line no-unreachable
      axios
        .get(url)
        .then((response) => {
        
          this.detalleReclamo = response.data.body;
          this.is_loading = false;
       
        })
        .catch(() => {
       
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },

  },
};
</script>



// WEBPACK FOOTER //
// ReclamoDetails.vue?1f5b45fd